import React, { useCallback, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { isDarkMode, setTheme } from '../utils/theme';
import { cn } from '../lib/utils';

export function ThemeToggle() {
  const [dark, setDark] = useState(isDarkMode);

  const toggleColorMode = useCallback(() => {
    const next = dark ? 'light' : 'dark';
    setTheme(next);
    setDark(!dark);
  }, [dark]);

  return (
    <div className="flex items-center gap-2">
      <Sun
        className={cn(
          'h-4 w-4 shrink-0',
          dark ? 'text-muted-foreground' : 'text-foreground'
        )}
        aria-hidden
      />
      <button
        type="button"
        role="switch"
        aria-checked={dark}
        aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
        onClick={toggleColorMode}
        className={cn(
          'relative inline-flex h-7 w-12 shrink-0 cursor-pointer items-center rounded-full border p-1 transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
          dark
            ? 'border-primary bg-primary'
            : 'border-border bg-muted'
        )}
      >
        <span
          className={cn(
            'pointer-events-none block h-5 w-5 rounded-full bg-background shadow ring-1 ring-black/5 transition-transform duration-200 ease-out',
            dark ? 'translate-x-5' : 'translate-x-0'
          )}
        />
      </button>
      <Moon
        className={cn(
          'h-4 w-4 shrink-0',
          dark ? 'text-foreground' : 'text-muted-foreground'
        )}
        aria-hidden
      />
    </div>
  );
}
